export const getNewOptimizerUrl = (url, keyword) => {
    const path = `${url}?keyword=${encodeURIComponent(keyword)}`;

    return path;
};
